import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const roleGuard: CanActivateFn = async () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const profile = await authService.getUserProfile();

    // ✅ FIX: Permitimos el acceso si es comercial O si es propietario
    if (profile?.role === 'comercial' || profile?.role === 'propietario') {
        return true;
    }

    // Si es un cliente u otro rol, lo devolvemos a su menú
    return router.createUrlTree(['/admin/menu']);
};